<template>
  <span
    v-tooltip="{ content: tooltipContent, classes: 'tooltip--new', html: false }"
    class="app-table-text"
    :tabindex="tooltipContent ? 0 : null"
    @mouseenter="measureOverflow"
    @focus="measureOverflow"
  ><slot>{{ displayText }}</slot></span>
</template>

<script>
export default {
  name: 'AppTableText',
  props: {
    text: { type: [String, Number], default: '' },
    fallback: { type: String, default: '—' },
    // Additional information can be shown even when the visible text fits.
    tooltip: { type: String, default: '' }
  },
  data() {
    return { overflowing: false }
  },
  computed: {
    hasValue() {
      return this.text !== null && this.text !== undefined && !['', '—', '–', '-'].includes(String(this.text).trim())
    },
    displayText() {
      return this.hasValue ? String(this.text) : this.fallback
    },
    tooltipContent() {
      if (!this.hasValue) return null
      if (this.tooltip && this.tooltip !== this.displayText) return this.tooltip
      return this.overflowing ? this.displayText : null
    }
  },
  mounted() {
    this.measureOverflow()
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.measureOverflow)
      this.resizeObserver.observe(this.$el)
    } else {
      window.addEventListener('resize', this.measureOverflow)
    }
    if (document.fonts) document.fonts.ready.then(() => {
      if (!this._isDestroyed) this.measureOverflow()
    })
  },
  updated() {
    this.measureOverflow()
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
    else window.removeEventListener('resize', this.measureOverflow)
  },
  methods: {
    measureOverflow() {
      this.overflowing = Boolean(this.$el && this.$el.clientWidth && this.$el.scrollWidth > this.$el.clientWidth)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-table-text {
  display: inline-block;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;

  &:focus-visible {
    outline: 2px solid $ui-blue;
    outline-offset: -2px;
  }
}
</style>
